import { stepperAnatomy as parts } from "@chakra-ui/anatomy"
import { createMultiStyleConfigHelpers } from "@chakra-ui/styled-system"

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys)

/**
 * @see {@link https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/stepper.ts}
 */
export const Stepper = defineMultiStyleConfig({
  baseStyle: {
    indicator: {
      color: "neutrals.500",
      "&[data-status=active]": {
        color: "main.700",
      },
    },
    title: {
      fontSize: 12,
      fontWeight: 400,
      color: "neutrals.600",
      "&[data-status=active]": {
        color: "neutrals.900",
      },
    },
    separator: {
      "&[data-orientation=horizontal]": {
        height: "1px",
      },
      "&[data-orientation=vertical]": {
        width: "1px",
      },
    },
  },
})
